module.exports = __webpack_public_path__ + "assets/a5a2d025aaec482df092b0af40799f10.svg";